/* Action Types */
export const createActionTypes = (actionTypeName) => ({
  START: `${actionTypeName}_START`,
  IN_PROGRESS: `${actionTypeName}_IN_PROGRESS`,
  SUCCESS: `${actionTypeName}_SUCCESS`,
  FAILURE: `${actionTypeName}_FAILURE`,
  RESET: `${actionTypeName}_RESET`
});

export const LOGIN_USER = createActionTypes('LOGIN_USER');
export const REGISTER_USER = createActionTypes('REGISTER_USER');
export const FORGOT_PWD = createActionTypes('FORGOT_PWD');
export const CHANGE_PWD = createActionTypes('CHANGE_PWD');
export const LOGOUT_USER = createActionTypes('LOGOUT_USER');
export const LOGGED_USER = createActionTypes('LOGGED_USER');

export const SWITCH_USER = createActionTypes('SWITCH_USER');
export const SWITCH_DATA = createActionTypes('SWITCH_DATA');

export const GET_SCENARIOS_REQUEST = 'GET_SCENARIOS_REQUEST';
export const ADD_SCENARIO_REQUEST = 'ADD_SCENARIO_REQUEST';
export const ADD_SCENARIO_SUCCESS = 'ADD_SCENARIO_SUCCESS';
export const ADD_SCENARIO_FAILED = 'ADD_SCENARIO_FAILED';
export const GET_SCENARIOS_SUCCESS = 'GET_SCENARIOS_SUCCESS';
export const GET_SCENARIOS_FAILED = 'GET_SCENARIOS_FAILED';
export const GET_DATASOURCES_REQUEST = 'GET_DATASOURCES_REQUEST';
export const GET_DATASOURCES_SUCCESS = 'GET_DATASOURCES_SUCCESS';
export const GET_DATASOURCES_FAILED = 'GET_DATASOURCES_FAILED';
export const SET_INPUTS = 'SET_INPUTS';
export const SET_OUTPUTS = 'SET_OUTPUTS';
export const RESET_DATA = 'RESET_DATA';

export const SHOW_TOAST = 'SHOW_TOAST';
